import { useMemo } from "react"

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@coval/ui"

import { useQueryParams } from "@/hooks/useQueryParams"
import { useSetPageHeader } from "@/hooks/useSetPageHeader"

interface NotebookPage {
  /** The open notebook's title, or null while one is still loading. */
  title: string | null
}

/**
 * Names the builder in the app's top bar after what is on it, "New notebook"
 * or the notebook's title, instead of the route segment.
 */
export function NotebookPageHeader({
  organizationSlug,
  workspaceId,
  title,
}: NotebookPage & { organizationSlug: string; workspaceId: string }) {
  const queryParams = useQueryParams()
  const notebooksHref = queryParams.getHref(
    "/home/notebooks",
    organizationSlug,
    workspaceId,
  )
  const label = title ?? "Notebook"
  const header = useMemo(
    () => (
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <Breadcrumb className="min-w-0">
          <BreadcrumbList className="flex-nowrap">
            <BreadcrumbItem>
              <BreadcrumbLink href={notebooksHref}>Notebooks</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem className="min-w-0">
              <BreadcrumbPage className="truncate" title={label}>
                {label}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    ),
    [label, notebooksHref],
  )
  useSetPageHeader(header)
  return null
}
